import useAuthMiddleware from "../../../../middlewares/AuthMiddleware";
import useCompanyTypeMiddleware from "../../../../middlewares/CompanyTypeMiddleware";
import useMiddlewares from "../../../../middlewares/Middleware";
import usePermissionMiddleware from "../../../../middlewares/PermissionMiddleware";
import useRoleTypeMiddleware from "../../../../middlewares/RoleTypeMiddleware";
import useRouteValidator from "../../RouteValidator";

export function useSaltoConfigsRouteValidator() {
  return useRouteValidator(
    useMiddlewares([
      useAuthMiddleware(),
      useCompanyTypeMiddleware(["default", "business_center"]),
      useRoleTypeMiddleware(["superadmin", "user"]),
      usePermissionMiddleware([
        "integrations.salto.configs.read",
        "integrations.salto.configs.read.screen",
      ]),
    ])
  );
}
